import { PackageUpIcon } from './PackageUpIcon';

/**
 * author: Austin Andrews
 * id 383EF914-6014-473D-8C54-0314432007E3
 * name package-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-up.svg
 * tags
 */
export const UnarchiveIcon = PackageUpIcon;
export default UnarchiveIcon